import { render } from "./GiftCardsPage.vue?vue&type=template&id=4ccec1d1&scoped=true"
import script from "./GiftCardsPage.vue?vue&type=script&lang=js"
export * from "./GiftCardsPage.vue?vue&type=script&lang=js"

import "./GiftCardsPage.vue?vue&type=style&index=0&id=4ccec1d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ccec1d1"]])

export default __exports__